/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}         from '@/util/i.command';
import {TrackIngress}     from '../../../helpers/track.ingress';
import {DiversionEditor}  from './diversion.editor';

/**
 *
 * @class SetEndTrackCommand
 *
 * @brief reversible updates of the ending track for a diversion
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetEndTrackCommand implements ICommand {

  private oldValue: TrackIngress;
  private newValue: TrackIngress;
  private editor:   DiversionEditor;

  constructor(oldValue: TrackIngress, newValue: TrackIngress, editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setEndTrack(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setEndTrack(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof TrackIngress) ? this.oldValue.asString() : '';
    const b = (this.newValue instanceof TrackIngress) ? this.newValue.asString() : '';

    return '[endtrack] ' + a + ' => ' + b;
  }

}
